<template>
    <BaseInput
        :value="value"
        type="number"
        @input="modelValue => $emit('input', modelValue)"
    />
</template>

<script>
import BaseInput from './BaseInput'

export default {
  components: { BaseInput },
  emits: ['input'],
  name: 'BaseInputNumber',
  props: ['value']
}
</script>

<style scoped>

</style>
